import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { ResponseContentType, Http } from '@angular/http';

import * as  ClientSettings from '../static/clientSettings';

import { ShuttleListData } from '../shared/models/shuttle-list-data.interface';
import { PlanningBlock } from '../pb-screen/models/planning-block/planning-block.interface';
import { HttpClientService } from '../shared/services/httpclient';

@Injectable()
export class ShuttleListService {

  public baseUrl: string = ClientSettings.clientSettings.containerPlanningApiUri + "print";


    constructor(
        private readonly http: HttpClientService
    ) { }


    public printShuttleList(pbs: PlanningBlock[], name: string): any{
        const data: ShuttleListData = {
           planningBlocks: [],
           name: "",
            type: {
              iD: 1,
            },
          };

        data.planningBlocks =
            pbs.sort((a, b) => (a.fileId > b.fileId) ? 1 : ((b.fileId > a.fileId) ? -1 : 0));
        data.name = name;

        return this.http.post(this.baseUrl + "/shuttlelist" , data, 'blob' )
        .map((res:any) =>
         window.open(window.URL.createObjectURL(res)))
        .catch((err) => {
          return Observable.throw(err);
        });
    }

}
